var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9709 37.7699C49.5251 41.1575 47.8614 44.267 45.2906 46.5176C42.7197 48.7682 39.4175 50.0061 36.0006 50C16.1503 50 2.2622e-05 33.8498 2.2622e-05 13.9996C-0.00610243 10.5828 1.23176 7.28062 3.48242 4.70978C5.73307 2.13894 8.8426 0.475266 12.2302 0.0294944C13.0869 -0.0751043 13.9544 0.10015 14.7032 0.529095C15.4521 0.958041 16.0421 1.61767 16.3853 2.40952L21.6654 14.1971V14.2271C21.9281 14.8333 22.0366 15.495 21.9812 16.1533C21.9258 16.8116 21.7082 17.446 21.3479 17.9997C21.3029 18.0672 21.2554 18.1297 21.2054 18.1922L16.0003 24.3622C17.8728 28.1673 21.8529 32.1123 25.708 33.9898L31.7931 28.8123C31.8528 28.762 31.9154 28.7153 31.9806 28.6723C32.5338 28.3033 33.1703 28.078 33.8325 28.0169C34.4947 27.9558 35.1617 28.0608 35.7731 28.3223L35.8056 28.3373L47.5833 33.6148C48.3766 33.9568 49.0378 34.5463 49.4682 35.2952C49.8986 36.0442 50.0749 36.9123 49.9709 37.7699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.01d82a64b06d15d89281436079869f2f.svg";
export { ForwardRef as ReactComponent };